module.exports = __webpack_public_path__ + "static/media/bezier-curve.3c05136e.svg";